var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-loader",class:{
        _cold: _vm.variant === 'cold',
        _dark: _vm.variant === 'dark',
        _light: _vm.variant === 'light',
    }})
}
var staticRenderFns = []

export { render, staticRenderFns }